<template>
    <div class="card-body prelative flex-column ai-center jc-center">
        <div class="div-block flex-column ov-hidden ai-center jc-center">
            <img :src="placeholderImg" alt="" width="120" />
            <div class="acenter gray-80 fs-4 bold">
                {{ $l10n.__('Un problème est survenu') }}
            </div>
            <slot name="placeholder">
                <p class="dinlineb gray-60 acenter fs-3">{{ placeHolderText }}</p>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholderImg: {
            type: String,
            required: false,
            default: '/ressources/logged/img/dashboard/fallback-card-blue.png',
        },
        placeHolderText: {
            type: String,
            required: false,
            default: '',
        },
    },
};
</script>

<style scoped>
.div-block {
    gap: 10px;
}
p {
    width: 200px;
}
</style>
